import { createAsyncAction } from "../utils/actionCreators";

export const types = {
  OBTER: "@@apoio/OBTER",
};

export const actions = {
  obterMaterialApoio: createAsyncAction(types.OBTER),
};
